export enum StatisticsSplitType {
    HOUR = 1,
    DAY = 2,
    WEEK = 3,
    MONTH = 4
}